/* completed.icon.svg.js */

module.exports = {
    icon: `    
        <svg viewBox="0 0 19.8 19.8" preserveAspectRatio="none">
            <path class="foreground-gl" d="M10.21.24a9.91,9.91,0,1,0,9.91,9.9A9.91,9.91,0,0,0,10.21.24Zm3.93,14.15H6.29A.32.32,0,0,1,6,14.07V6.22a.33.33,0,0,1,.33-.33h7.85a.32.32,0,0,1,.32.33v7.85A.32.32,0,0,1,14.14,14.39Z" transform="translate(-0.31 -0.24)"/>
        </svg>
     `
};
